import { render, staticRenderFns } from "./ComixGenre.vue?vue&type=template&id=7296cefa&scoped=true&"
import script from "./ComixGenre.vue?vue&type=script&lang=js&"
export * from "./ComixGenre.vue?vue&type=script&lang=js&"
import style0 from "./ComixGenre.vue?vue&type=style&index=0&id=7296cefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296cefa",
  null
  
)

export default component.exports